import { forwardRef } from "react";
import "../button/styles.css";

// type ButtonVariants =
//   | "primary"
//   | "ghost"
//   | "icon"
//   | "timeframe"
//   | "table"
//   | "link"
//   | "default";

// type ButtonSubVariants =
//   | "primary"
//   | "success"
//   | "failure"
//   | "warning"
//   | "primary-hover";

// interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
//   children: ReactNode;
//   variant: ButtonVariants;
//   subVariant?: ButtonSubVariants;
//   icon?: ReactNode;
//   className?: string;
//   isActive?: boolean;
// }

const Button = forwardRef(
  (
    {
      children,
      variant = "primary",
      subVariant = "",
      icon,
      className,
      isActive,
      style,
      disabled = false,
      ...props
    },
    ref,
  ) => {
    const baseButton = "button";
    const variantButton = `button-${variant}`;
    const subVariantButton =
      variant === "table" && subVariant ? `button-table-${subVariant}` : "";

    const subVariantTableStaticButton =
      variant === "table-options-menu-static" && subVariant
        ? `button-table-options-menu-static-${subVariant}`
        : "";

    const subVariantTableButton =
      variant === "table-options-menu" && subVariant
        ? `button-table-options-menu-${subVariant}`
        : "";

    const linkButton = isActive ? `button-${variant}-active` : "";

    const disabledBtn =
      variant === "primary" || variant === "blueButtonBig"
        ? `button-${variant}-disabled`
        : "button-disabled";

    const isTextFirstVariant =
      variant === "primary" ||
      variant === "timeframe" ||
      variant === "table" ||
      variant === "table-options-menu" ||
      variant === "table-options-menu-static" ||
      variant === "blue-button";
    console.log({ variant, disabled, disabledBtn, variantButton });
    return (
      <button
        ref={ref}
        className={`${baseButton} ${variantButton} ${subVariantButton} ${subVariantTableButton} ${subVariantTableStaticButton} ${linkButton} ${
          disabled && disabledBtn
        } ${className || ""}`}
        style={style}
        disabled={disabled}
        {...props}
      >
        {isTextFirstVariant ? (
          <>
            {children}
            {icon && <span>{icon}</span>}
          </>
        ) : (
          <>
            {icon && <span>{icon}</span>}
            {children}
          </>
        )}
      </button>
    );
  },
);

export default Button;
